import React from "react";
import Image from "../Image";

export interface IItem {
  key: string;
  name: string;
  link: string;
  image: string;
}

export interface ISection {
  question: string;
  items: IItem[];
}

const getPathImage = (path: string) =>
  path.includes("http")
    ? path
    : `${process.env.MEDIA_URL}/media/images/products/${path}`;

const Products = ({
  startOver,
  step,
  data: { question, items },
}: {
  startOver: Function;
  step: number;
  data: ISection;
}) => (
  <section
    id={step.toString()}
    className="mmmTapesWalmart-step mmmTapesWalmart-products"
  >
    <h2
      className={`mmmTapesWalmart-step-header ${
        items.length <= 0 ? "no-products-found" : ""
      }`}
    >
      {question}
    </h2>
    <ul className="mmmTapesWalmart-products_container">
      {items.map(({ name, image, link }, i) => (
        <li key={i} className="mmmTapesWalmart-card">
          <a href={link}>
            <Image
              src={getPathImage(image)}
              name={name}
              className="mmmTapesWalmart-product_image"
            />
            <div className="mmmTapesWalmart-product_name">
              <h2>{name}</h2>
            </div>
            <p className="mmmTapesWalmart-button-selector">Buy this Product</p>
          </a>
        </li>
      ))}
    </ul>
    <button
      onClick={() => startOver()}
      className="mmmTapesWalmart-restart-selector"
    >
      Start Over
    </button>
  </section>
);

export default Products;
